import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { CreateButton } from '../../../buttons';
import { EditDialog, Filter, NestedResourceList, ResourceList, ResourceShow, Tab, TabbedShowLayout } from '../../../controllers';
import { BooleanField, EnumField, JavaScriptField, KidScriptField, LinkField, NumberField, TextField } from '../../../fields';
import { BooleanInput, EnumInput, JavaScriptInput, NestedReferenceInput, ReferenceInput, SearchInput, TextInput } from '../../../inputs';
import library_object_method_modules from './library_object_method_modules';
import library_object_method_parameters from './library_object_method_parameters';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextField
          source="name"
        />
        <BooleanField
          source="internal"
        />
        <ReferenceInput
          source="library_keyring_id"
        />
        <BooleanInput
          source="super_power"
        />
        <TextInput
          source="description"
        />
        <JavaScriptInput
          source="javascript"
        />
        <EnumInput
          source="return_type"
          versionedAttribute
        />
        <NestedReferenceInput
          optionText="address"
          resourcePath={`/library_objects/${props.parentResource.parentResource.id}`}
          source="library_object_configuration_value_id"
        />
        <TextInput
          source="object_configuration_value_value"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ library_object_id: props.parentResource.id }}
        {...props}
      >
        <TextInput
          source="name"
        />
        <BooleanInput
          source="internal"
        />
        <ReferenceInput
          source="library_keyring_id"
        />
        <BooleanInput
          source="super_power"
        />
        <TextInput
          source="description"
        />
        <JavaScriptInput
          source="javascript"
        />
        <EnumInput
          source="return_type"
          versionedAttribute
        />
        <NestedReferenceInput
          optionText="address"
          resourcePath={`/library_objects/${props.parentResource.id}`}
          source="library_object_configuration_value_id"
        />
        <TextInput
          source="object_configuration_value_value"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
        <TextField
          source="description"
        />
        <BooleanField
          source="internal"
        />
        <LinkField
          source="library_keyring_id"
          allowEmpty
        />
        <EnumField
          source="return_type"
          versionedAttribute
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TabbedShowLayout>

          <Tab
            label="Preview"
          >
            <JavaScriptField
              source="preview"
            />
          </Tab>

          <Tab
            label="General"
          >
            <TextField
              source="name"
            />
            <LinkField
              source="library_keyring_id"
              allowEmpty
            />
            <TextField
              source="description"
            />
            <BooleanField
              source="internal"
            />
            <BooleanField
              source="super_power"
            />
            <KidScriptField
              source="kidscript"
            />
            <JavaScriptField
              source="javascript"
            />
            <EnumField
              source="return_type"
              versionedAttribute
            />
          </Tab>

          <Tab
            label="Parameters"
          >
            <NestedResourceList
              reference="library_object_method_parameters"
            >
              <NumberField
                source="position"
              />
              <TextField
                source="name"
              />
              <EnumField
                source="class_name"
                versionedAttribute
              />
            </NestedResourceList>
          </Tab>

          <Tab
            label="Modules"
          >
            <NestedResourceList
              reference="library_object_method_modules"
            >
              <TextField
                source="name"
              />
            </NestedResourceList>
          </Tab>

        </TabbedShowLayout>
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
    library_object_method_modules,
    library_object_method_parameters,
  },
};
